<template>
  <div>

    <b-sidebar id="add-new-garden-plan-sidebar" v-model="isSidebarActive" bg-variant="white"
               sidebar-class="sidebar-lg" width="40%" shadow backdrop no-header left @hidden="sideBarHidden">
      <template #default="{ hide }">

        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">{{ $t('Add New Garden Plan') }}</h5>
          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>

        <div class="loading_page" v-if="form.busy">
          <orbit-spinner :animation-duration="1000" :size="20" :color="'#0e96b1'" />
        </div>


        <validation-observer ref="addPlanFormValidatorRef">
          <b-form class="p-2" :disabled="edit">

          <b-form-group :label="$t('Enter Plan Name')" label-for="plan-name">
            <validation-provider #default="{ errors }" rules="required" name="Plan Name">
            <b-form-input id="plan-name" v-model="form.plan.name" :state="errors.length > 0 ? false:null" :placeholder="$t('Enter Plan Name')"/>
            <input-error :form="form" field="name"></input-error><small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group :label="$t('Choose the geofence')" label-for="select-geofence">
            <validation-provider #default="{ errors }" rules="required" name="Garden">
              <v-select :disabled="edit" id="select-geofence" v-model="form.plan.plannable_id" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="geofences" :reduce="g => g.geofence_id" :getOptionLabel="g => g.name"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

            <input-error :form="form" field="plannable_id"></input-error>
          </b-form-group>

          <b-form-group :label="$t('Start Date')" label-for="start-date">
            <validation-provider #default="{ errors }" rules="required" name="Start Date">
              <flat-pickr  :disabled="edit" id="start-date" :state="errors.length > 0 ? false:null" v-model="form.plan.starts_at" class="form-control" :config="pickerConf"/>
              <input-error :form="form" field="starts_at"></input-error>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <h6>{{$t('Plan Shifts')}}  <feather-icon icon="PlusCircleIcon" v-b-modal.modal.add-shift /> </h6>
          <input-error :form="form" field="shifts"></input-error>
          <b-button id="add-new-shift" variant="flat-success" class="btn-icon" >

          </b-button>

          <table class="table table-sm">
            <thead>
            <tr>
              <th>name</th>
              <th>from</th>
              <th>to</th>
              <th>count</th>
              <th>duration</th>
              <th>
                <feather-icon icon="MinusCircleIcon"/>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(shift, i) in form.plan.shifts" :key="shift.uuid">
              <td>{{shift.name}}</td>
              <td>{{shift.start_period}}</td>
              <td>{{shift.end_period}}</td>
              <td>{{shift.data.count}}</td>
              <td>{{shift.data.duration}}</td>
              <td>
                <b-button variant="flat-danger" style="padding: 0" class="btn-icon" @click="removeShift(i)">
                  <feather-icon icon="MinusCircleIcon" />
                </b-button>
              </td>
            </tr>
            </tbody>
          </table>

          <b-button v-if="!edit" size="sm" variant="primary" @click="submitPlan" :disabled = "form.busy">
            <orbit-spinner v-if="form.busy" :animation-duration="1000" :size="10" :color="'white'" />
            <template v-else>{{$t('Save')}}</template>
          </b-button>

          <b-button v-else size="sm" variant="primary" @click="submitUpdatePlan" :disabled = "form.busy">
            <orbit-spinner v-if="form.busy" :animation-duration="1000" :size="10" :color="'white'" />
            <template v-else>{{$t('Edit')}}</template>
          </b-button>

        </b-form>
        </validation-observer>

      </template>
    </b-sidebar>

    <!--   button -->
    <b-card no-body class="mb-1">
      <div class="m-2">
        <b-row>
          <b-col cols="12" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <b-button variant="primary" v-b-toggle.add-new-garden-plan-sidebar type="button">{{ $t('New') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal ref="confirmationModal"
             id="confirmation-plan-modal"
             :title="$t('Action Confirmation')" size='sm'>

      <p>{{$t('this geofence has other opened plan, Do you want to close it and start new one?')}}</p>

      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="primary" @click="submitConfirmation" :disabled = "confirmationForm.busy">
          <orbit-spinner v-if="confirmationForm.busy" :animation-duration="1000" :size="10" :color="'white'" />
          <template v-else>{{$t('ok')}}</template>
        </b-button>
      </template>
    </b-modal>

    <b-modal ref="confirmationDeletePlan" id="confirmation-delete-plan" :title="$t('Delete Plan Confirmation')" size='sm' @hidden="planToDelete = null">
      <p>{{$t('Do you want to delete this plan?') }}</p>
      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="primary" @click="submitPlanDeletion">
          <template>{{$t('delete')}}</template>
        </b-button>
      </template>
    </b-modal>

    <b-modal ref="addShiftRef" id="add-shift" :title="$t('Add Shift To Plan')" size='md' @hidden="addShiftHidden">

      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="primary" @click="addShift"> {{$t('add')}}</b-button>
      </template>

      <validation-observer ref="addShiftFormValidatorRef">
      <b-form>
      <b-row>
        <b-col  lg="12">
          <b-form-group :label="$t('Enter Shift Name')" label-for="plan-name">
            <validation-provider #default="{ errors }" rules="required" name="Plan Name">
              <b-form-input v-model="shift.name" id="plan-name" :state="errors.length > 0 ? false:null" :placeholder="$t('Enter Plan Name')"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12" lg="6">
          <b-form-group :label="$t('Shift Start')" label-for="shift-start">
            <validation-provider #default="{ errors }" rules="required" name="shift start">
              <flat-pickr id="shift-start" :state="errors.length > 0 ? false:null" v-model="shift.start_period" class="form-control" :config="{defaultHour:0, ...timeConf}"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12" lg="6">
          <b-form-group :label="$t('Shift End')" label-for="shift-end">
            <validation-provider #default="{ errors }" rules="required" name="shift end">
              <flat-pickr id="shift-end" v-model="shift.end_period" :state="errors.length > 0 ? false:null" class="form-control" :config="{defaultHour:23, defaultMinute:59,...timeConf}"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12" lg="6">
          <b-form-group :label="$t('Serve Count')" label-for="serve-count">
            <validation-provider #default="{ errors }" rules="required|integer|greaterThanZero" name="count">
              <b-form-input id="serve-count" :state="errors.length > 0 ? false:null" v-model="shift.data.count" :placeholder="$t('How many times')"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12" lg="6">
          <b-form-group :label="$t('Duration')" label-for="duration">
            <validation-provider #default="{ errors }" rules="required|integer|greaterThanZero" name="duration">
              <b-form-input id="duration" :state="errors.length > 0 ? false:null" v-model="shift.data.duration" :placeholder="$t('Duration in minutes')"/>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

      </b-row>
      </b-form>
      </validation-observer>
    </b-modal>

    <b-card no-body class="mb-0">
      <div class="m-2">

        <b-row>
          <b-col cols="12" sm="3" md="3" lg="1">
            <v-select id="per-page" v-model="perPage" :clearable="false" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="[20,50,100,500]"/>
          </b-col>

          <b-col cols="10" sm="8" md="8" lg="9" >
            <b-form-input id="search" @keydown.enter="executeOnEnter" v-model="filter" :placeholder="$t('Filter By any text ...')"/>
          </b-col>

          <b-col cols="1" sm="1" md="1" lg="2">
            <b-button variant="primary" :disabled ="exportBusy" class="btn-icon mr-1 ml-1" @click="exportList('xlsx')">
              <orbit-spinner v-if="exportBusy" :animation-duration="1000" :size="10" :color="'white'" />
              <template v-else>
                EXCEL <feather-icon icon="DownloadCloudIcon" />
              </template>
            </b-button>
          </b-col>

          <b-col cols="12" class="mt-1">
            <b-table ref="myTable" id="PlansTable" :filter="filter" small bordered hover responsive="sm" :per-page="perPage" :current-page="currentPage"
                     :busy="tableBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :fields="columns" :items="items">

              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>

              <template #cell(edit)="data">
                <b-button variant="flat-primary" style="padding: 0" class="btn-icon" @click="showPlan(data)">
                <feather-icon icon="EditIcon" />
                </b-button>
              </template>

              <template v-slot:head(delete)="data">
                <feather-icon icon="MinusCircleIcon" />
              </template>

              <template #cell(delete)="data">
                <b-button variant="flat-danger" style="padding: 0" class="btn-icon" @click="removePlan(data.item)">
                  <feather-icon icon="MinusCircleIcon" />
                </b-button>
              </template>

              <template #table-busy>
                <div class="my-2" style=" justify-content: center; align-items: center; display: flex;">
                  <orbit-spinner class="align-middle" :animation-duration="1000" :size="20" :color="'#27afba'" />
                </div>
              </template>

            </b-table>

            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                aria-controls="PlansTable"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

  </div>
</template>

<script>
import Vue from "vue"
import { ref, onMounted, reactive, watch } from '@vue/composition-api'
import CustomTable from '@/new/components/CustomTable'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import axios from '@/libs/axios'
import { OrbitSpinner } from 'epic-spinners'
import { SearchIcon,  DownloadCloudIcon, PrinterIcon} from 'vue-feather-icons'
import ToastContent from '@core/components/toastification/CustomToastContent'
import trans from '@/libs/i18n'
import Form from '@/libs/vForm'
import { v4 as uuid } from 'uuid'
import InputError from '@/new/components/InputError'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, integer, min,length, greaterThanZero} from '@validations'
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BForm,
  BFormValidFeedback,
  BFormInvalidFeedback,
  BFormGroup,
  BInputGroup,
  BModal,
  BTable,
  BPagination,
  BSidebar,
} from 'bootstrap-vue'



export default {
  components: {
    SearchIcon,DownloadCloudIcon,PrinterIcon,
    ValidationProvider, ValidationObserver,
    InputError,
    BFormValidFeedback,BFormInvalidFeedback,
    OrbitSpinner,
    vSelect,  flatPickr, BTable, BPagination,
    BCard,BCol, BRow,BButton,
    BFormGroup, BInputGroup, BFormInput, BForm,
    CustomTable, BModal, BSidebar
  },

  setup() {

    const blankShift = {
      name: '',
      start_period: '',
      end_period: '',
      data: {
        count: 0,
        duration: 0
      }
    }

    const blankPlan = {
      id: null,
      name: "",
      plannable: 'geofence',
      plannable_id: '',
      starts_at: '',
      shifts: [],
    }

    const filter = ref('')

    const isSidebarActive = ref(false)
    const editMode = ref(false)

    const addShiftFormValidatorRef = ref(null);
    const addPlanFormValidatorRef = ref(null);
    const confirmationModal = ref(null);
    const confirmationDeletePlan = ref(null);
    const addShiftRef = ref(null);

    // table
    const myTable = ref(null)
    const currentPage = ref(1)
    const perPage = ref(10)
    const tableBusy = ref(false)
    const sortBy = ref('')
    const sortDesc = ref('')
    const totalRows = ref(0)
    const items = ref([])

    const exportBusy = ref(false)

    const form = reactive(new Form({
      type: "garden",
      plan: {... blankPlan}
    }));

    const edit = ref(false)

    const toggleShowEdit = () => {
      edit.value = !edit.value
    }

    const confirmationForm = reactive(new Form({
      type: 'garden',
      action: 'create',
      confirmationToken: ''
    }))

    const shift = reactive({...blankShift})

    const rows = ref([])
    const geofences = ref([])

    const pickerConf = { dateFormat: 'Y-m-d',  altInputClass: 'small'};
    const timeConf = { dateFormat: 'H:i:S', enableSeconds: true, enableTime: true, noCalendar: true, time_24hr: true, altInputClass: 'small'};
    const columns = ref([{ key: 'index',label: '#' ,sortable: true },{ key: 'owner', sortable: true },{ key: 'contract', sortable: true },{ key: 'name', sortable: true }, { key: 'geofence', sortable: true }, { key: 'starts_at', sortable: true }, { key: 'ends_at', sortable: true },
      { key: 'count', sortable: true },{key: 'edit'}, {key: 'delete'}])

    const addShift = (bvModalEvent) => {
      bvModalEvent.preventDefault()

      addShiftFormValidatorRef.value.validate().then(success => {
        if (success) {
          form.plan.shifts.push({uuid: uuid(),...shift})
          addShiftRef.value.hide()
        }
      })
    }


    const showPlan = data => {
      isSidebarActive.value = true
      edit.value = true
      Object.assign(form, {plan:{...data.item, shifts: [...data.item.shifts]}})
    }


    const planToDelete = ref(null)
    const removePlan = plan => {
      planToDelete.value = plan
      confirmationDeletePlan.value.show()
    }


    const submitPlanDeletion = () => {
      if (planToDelete.value) {
        form.delete(`gplans/${planToDelete.value.id}`).then(response => {
          if (response.status === 200) {
            confirmationDeletePlan.value.hide()
            getData()
            Vue.$toast({
              component: ToastContent,
              props: { title: `${trans.t('plan deleted successfully')}`, },
            });
          }

        }).catch(e => {
          console.log(e)
          // Vue.$toast({
          //   component: ToastContent,
          //   props: { title: `${trans.t('plan deleted successfully')}`, },
          // });
        })
      }
    }

    const submitUpdatePlan = () => {
      addPlanFormValidatorRef.value.validate().then(success => {
        if (success) {
          form.put(`gplans/${form.plan.id}`).then(response => {
            if (response.status === 200) {
              Vue.$toast({
                component: ToastContent,
                props: { title: `${trans.t('plan updated successfully')}`, },
              });
            }
          })
        }
      })
    }

    const submitConfirmation = async (bvModalEvent) => {
      bvModalEvent.preventDefault()
      try {
        let response = await confirmationForm.post('gplansConfirm')

        if (response.status === 201) {

          getData()
          resetPlanModal()
          confirmationModal.value.hide()

          Vue.$toast({
            component: ToastContent,
            props: { title: `${trans.t('plan added successfully')}`, },
          });
        }
      }

      catch (e) {
        console.log('error on confirmation')
      }

    }

    const addShiftHidden = () => {
      resetShiftModal()
    }

    const resetShiftModal = () => {
      Object.assign(shift, {...blankShift, data: {
          count: 0, duration: 0 }})
    }



    const sideBarHidden = () => {
      resetPlanModal()
      edit.value = false
    }

    const resetPlanModal = () => {
      Object.assign(form, {plan:{...blankPlan, shifts: []}})
    }

    const removeShift = (index) => {
      form.plan.shifts.splice(index, 1);
    }


    const executeOnEnter = event => {
      if (event.keyCode === 13) {
        getData()
      }
    }




    const exportEXCEL = () => {
      const promise = axios.get('gplans', {params: {type: 'garden'}});
    }

    const exportList = type => {
      exportBusy.value = true
        axios.post('export', { exporter: type, export: 'gGardenPlanList'
          }, { responseType: 'blob' }).then(response => {

          exportBusy.value = false
          const blob = new Blob([response.data], { type: response.headers['content-type'], encoding: 'UTF-8' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `gardenPlanList.${type}`;
          link.click();
          URL.revokeObjectURL(url);
        }).catch(e => {
          exportBusy.value = false
          console.log(e)
          console.log('error export list')
        })

    }


    const getData = () => {

      tableBusy.value = true
      const promise = axios.get('gplans', {params: {type: 'garden'}});
      return promise.then(response => {

        tableBusy.value = false
        totalRows.value = response.data.data.length
         items.value = response.data.data

      }).catch(error => {
            tableBusy.value = false
      })
    }


    const getGeofences = () => {
      axios
          .get('authSelect', {params: {type: 'geofence', typeSlug: 'TANK_AREA'}})
          .then(response => geofences.value = response.data).catch(e => console.log(e))
    }


    const submitPlan =  bvModalEvent => {
      bvModalEvent.preventDefault()

      addPlanFormValidatorRef.value.validate().then(success => {
        if (success)
        {
           form.post('gplans').then(response => {
             if (response.status === 202)
             {
               confirmationForm.confirmationToken = response.data.confirmation_token
               confirmationModal.value.show()
             }
             else
             {
               getData()
               resetPlanModal()
               addShiftRef.value.hide()

               Vue.$toast({
                 component: ToastContent,
                 props: { title: `${trans.t('plan added successfully')}`, },
               });
             }
           }).catch(e => {
             if (e.response.status === 422)
             {
               Vue.$toast({
                 component: ToastContent,
                 props: { title: `${trans.t('Error, Some data is missing')}`, },
               });
             }
           })
        }
      })
    }


    onMounted(() => {
      getGeofences()
      getData()
    });


    return {

      exportBusy,
      items,

      toggleShowEdit, edit,
      // sidebar
      isSidebarActive, editMode,

      // table and pagination
      myTable, filter,
      currentPage, perPage, tableBusy, columns,
      rows, totalRows,


      sortDesc, sortBy,
      addShiftFormValidatorRef,addShiftRef, addPlanFormValidatorRef,
      confirmationModal,

      form, confirmationForm, confirmationDeletePlan,
      shift, planToDelete,
      geofences,
      pickerConf,timeConf,


      exportList,
      sideBarHidden,
      submitUpdatePlan,
      resetPlanModal,
      showPlan,removePlan,
      executeOnEnter,
      addShift, removeShift,
      submitPlan,
      addShiftHidden,
      submitConfirmation, submitPlanDeletion,
      getData, exportEXCEL,

      required, integer, min,length, greaterThanZero
    }

  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
